/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Why distribute-until-breakpoint did not grow this ratchet, or stopped it short
 */
export enum RatchetGrowthNoteKind {
    SUBJECT_OWNS_RATCHET = 'SUBJECT_OWNS_RATCHET',
    FROZEN_OWN_TARGET = 'FROZEN_OWN_TARGET',
    STOPPED_BY_OTHER_TARGET = 'STOPPED_BY_OTHER_TARGET',
    STOPPED_EARLY = 'STOPPED_EARLY',
}
